import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule, MatHint, MatLabel} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatRadioModule} from "@angular/material/radio";
import {MatNativeDateModule, provideNativeDateAdapter} from "@angular/material/core";
import {CommonModule} from "@angular/common";
import {MatSelectModule} from "@angular/material/select";
import {RentalPropertyModel} from "../../../domain/models/rental-property.model";
import {RentalPropertyStatus} from "../../../domain/enums/rental-property-status.enum";
import {FrequencyLabelMap} from "../../../domain/enums/occupation-freq.enum";

@Component({
  selector: 'app-reactivate-dialog',
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [MatDialogModule, MatButtonModule, MatIconModule,
    MatRadioModule, MatFormFieldModule, MatInputModule, MatLabel,
    ReactiveFormsModule, MatDatepickerModule, MatHint,
    MatNativeDateModule, CommonModule, FormsModule, MatSelectModule],
  templateUrl: './reactivate-dialog.component.html',
  styleUrl: './reactivate-dialog.component.css'
})
export class ReactivateDialogComponent implements OnInit{
  reactivateForm!: FormGroup;
  constructor(
    private fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<ReactivateDialogComponent>) {
  }

  buildForm(){
    this.reactivateForm = this.fb.group({
      startedRenting: ['', Validators.required],
      frequency: ['', Validators.required]
    });
  }

  private getReactivateValues(): RentalPropertyModel {
    let formValues = this.reactivateForm.value;
    return {
      startedRenting: formValues.startedRenting,
      filingFrecuency: formValues.frequency,
      status: RentalPropertyStatus.ACTIVE,
    } as RentalPropertyModel;
  }

  reactivate() {
    if (this.reactivateForm.valid) {
      let data = this.getReactivateValues();
      this.dialogRef.close(data);
    }
  }

  ngOnInit(): void {
    this.buildForm();
  }

  protected readonly FrequencyLabelMap = FrequencyLabelMap;
}
